import { getClusterInfoActionVL } from 'store/actions/vectorLayers';
import { checkEqualWkt } from 'components/MapComponent/constants';
import { Feature } from 'ol';
import { boundingExtent } from 'ol/extent';
import { Geometry } from 'ol/geom';
import { Circle, Fill, Stroke, Style, Text } from 'ol/style';

export const getStyle = (
  styleCache: any,
  oked_colors: { [key: string]: string }
) => {
  return function (feature, resolution) {
    let size = feature.get('features').length;
    let style = styleCache[size];
    if (!style) {
      let radius = Math.max(8, Math.min(size * 0.75, 20));

      if (size === 1) {
        let f = feature.get('features');
        const oked = f[0].get('oked');
        const color = oked_colors[oked] || '#000';

        style = new Style({
          image: new Circle({
            radius: 10,
            stroke: new Stroke({
              color: 'black',
              width: 1,
            }),
            fill: new Fill({
              color: color,
            }),
          }),
        });
      } else {
        style = styleCache[size] = new Style({
          image: new Circle({
            radius: radius,
            stroke: new Stroke({
              color: 'black',
              width: 1,
            }),
            fill: new Fill({
              color: 'white',
            }),
          }),
          text: new Text({
            text: size.toString(),
            fill: new Fill({
              color: 'black',
            }),
          }),
        });
      }
    }
    return style;
  };
};

export const featureStyle = (
  feature: any,
  oked_colors: { [key: string]: string }
) => {
  return function (feature: any) {
    let sel = feature.get('features');
    if (!sel) return;

    const oked = sel[0].get('oked');
    const color = oked_colors[oked] || '#000';

    return [
      new Style({
        image: new Circle({
          radius: 10,
          stroke: new Stroke({
            color: 'black',
            width: 1,
          }),
          fill: new Fill({
            color: color,
          }),
        }),
      }),
    ];
  };
};

export const clusterClickHandler = (
  map: any,
  dispatch: any,
  layersData: any,
  currentLayerId: number,
  isLog: boolean
) => {
  return (evt: any) => {
    const feature = map.forEachFeatureAtPixel(
      evt.pixel,
      (feature: Feature<Geometry>) => feature
    );

    if (!feature) {
      layersData.forEach((item) => {
        item.selectCluster.clear();
      });
      return;
    } else {
      const coord = evt.coordinate;
      const features = feature.values_.features;

      if (features.length === 1) {
        const gid = features[0].get('gid');
        dispatch(getClusterInfoActionVL(isLog, gid, currentLayerId, coord));
      }
    }

    const features = feature?.values_.features;
    const index = features[0].get('index');

    const { vectorLayer } = layersData[index];
    const { selectCluster } = layersData[index];

    vectorLayer.getFeatures(evt.pixel).then((clickedFeatures) => {
      if (clickedFeatures.length) {
        // Get clustered Coordinates
        const features = clickedFeatures[0].get('features');

        const featuresWkt = features.map((item) => {
          return item.get('wkt');
        });
        const currentZoom = map.getView().getZoom();
        const maxZoom = map.getView().getMaxZoom();

        const isMaxZoom = currentZoom === maxZoom;
        const equalWkt = checkEqualWkt(featuresWkt);

        if (features.length > 1 && !equalWkt && !isMaxZoom) {
          const extent = boundingExtent(
            features.map((r) => r.getGeometry().getCoordinates())
          );
          map
            .getView()
            .fit(extent, { duration: 1000, padding: [50, 50, 50, 50] });
        } else if (features.length > 1 && (equalWkt || isMaxZoom)) {
          if (!map.getInteractions().getArray().includes(selectCluster)) {
            map.addInteraction(selectCluster);
          }
        }
      }
    });
  };
};
